import { guardianLink } from './constants';
import { ROLES } from './enums';
import { UserProfile } from './types';

interface RolePermissions {
  role: string;
  permissions: string[];
}

export const getLoggedInUser = (auth: any) => {
  const loggedInUser: UserProfile = {
    given_name: auth.user?.profile?.given_name,
    family_name: auth.user?.profile?.family_name,
    email: auth.user?.profile?.email,
    phone: !!auth.user?.profile?.guardianPermissions?.userAccounts[0]?.additionalInfo?.phone
      ? auth.user?.profile?.guardianPermissions?.userAccounts[0]?.additionalInfo?.phone
      : '',
    apps: [
      {
        name: 'Prepayment Insight & Review',
        id: '7c7-4ff9-b4a8-8e0a00354d8a',
        uri: 'https://sdfkjldfskjl.chhc.io',
      },
    ],
    permissions: [],
    user_id: auth.user?.profile?.preferred_username,
    isInternalUser: false,
  };

  const guardianPermissions: any = auth?.user?.profile?.guardianPermissions;
  const extractedPermissions: string[] = [];
  if (guardianPermissions?.userAccounts && typeof guardianPermissions.userAccounts != 'undefined') {
    for (const userAccount of guardianPermissions.userAccounts) {
      for (const clientPartner of userAccount?.organization?.clientPartners ?? []) {
        extractedPermissions.push(...clientPartner.permissions);
      }
    }
  }
  const rolePermissions = createPermissionAndRoleSets(extractedPermissions);
  loggedInUser.permissions = rolePermissions;
  const accountWithPermission = guardianPermissions?.userAccounts?.find((userAccount: any) =>
    userAccount?.organization?.clientPartners?.some((clientPartner: any) =>
      clientPartner.permissions?.some((permission: string) => permission.includes('LNK-PREPAYWE-5161') || permission.includes('LNK-PREPAYWE-585'))
    )
  );
  loggedInUser.isInternalUser = accountWithPermission?.isInternalUser ?? false;

  return loggedInUser;
};

const createPermissionAndRoleSets = (extractedPermissions: string[]): RolePermissions[] => {
  const rolePermissions: RolePermissions[] = [];

  for (const extractedPermission of extractedPermissions) {
    const [application, role, permissionAction] = extractedPermission.split(':');
    if (application === guardianLink) {
      //Find the role in the existing rolePermissions Array
      let existingRole = rolePermissions.find((rp) => rp.role === role);

      //if the role doesn't exist, create a new entry
      if (!existingRole) {
        existingRole = { role, permissions: [] };
        rolePermissions.push(existingRole);
      }

      if (!existingRole.permissions.includes(permissionAction)) {
        existingRole.permissions.push(permissionAction);
      }
    }
  }
  return rolePermissions;
};
